import React, { Component } from 'react';

import ModalPage from '../../common/NonConnectedModalPage';
import Spacer from '../../common/Spacer';
import SpinButton from '../../common/SpinButton';
import TrTitle, { PageCategories } from '../../common/TrTitle';

import { browserHistory } from '../../services/history';
import { parseSearch } from '../../services/sharedUtils';
import locationShape from '../../common/locationShape';
import { changePassword } from '../../services/iggloBack';
import tr from '../../localization/translate';
import observeUnmounting from '../../services/observeUnmounting';

import logo from '../../assets/images/igglo-logo.svg';
import './ResetPassword.scss';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.updatePassword = this.updatePassword.bind(this);
    this.toggleShowHide = this.toggleShowHide.bind(this);
    this.postNewPassword = this.postNewPassword.bind(this);
    this.properPassword = this.properPassword.bind(this);

    this.state = {
      showText: false,
      newPassword: '',
      query: parseSearch(props.location.search),
      inProgress: false
    };

    this.unsubscribeOnUnmount = observeUnmounting(this);
  }

  updatePassword(e) {
    this.setState({ newPassword: e.target.value });
  }

  toggleShowHide() {
    this.setState(state => ({ showText: !state.showText }));
  }

  postNewPassword(e) {
    e.preventDefault();

    this.setState({ inProgress: true });

    this.unsubscribeOnUnmount(
      changePassword({
        sync_token: this.state.query.token,
        email: this.state.query.email,
        new_password: this.state.newPassword
      })
        .subscribe(
          () => browserHistory.push('/password_changed', { nextUrl: this.state.query.redirect_url }),
          () => {
            this.setState({ inProgress: false });
            alert(tr('reset_password.failure')); // eslint-disable-line no-alert
          }
        )
    );
  }

  properPassword() {
    return this.state.newPassword.length >= 8;
  }

  render() {
    return (
      <ModalPage tag="form" onSubmit={this.postNewPassword}>
        <TrTitle
          category={PageCategories.EMAIL}
          name="Reset password"
          title="reset_password"
          params={{ email: this.state.query.email }}
        />

        <img src={logo} alt={tr('common.logo_alt')} styleName="logo" />

        <Spacer />

        <div style={{ width: '100%' }}>
          <label htmlFor="new_password" className="label" styleName="label">
            { tr('reset_password.new_password') }
          </label>
          <div className="inputWrapper" styleName="marginless_input_wrapper">
            <input
              id="new_password"
              type={this.state.showText ? 'text' : 'password'}
              className="input"
              value={this.state.newPassword}
              onChange={this.updatePassword}
              autoComplete="new-password"
            />
            <button
              className="naked_button"
              styleName="show_hide_button"
              onClick={this.toggleShowHide}
              type="button"
            >
              { this.state.showText ?
                tr('reset_password.hide_password') :
                tr('reset_password.show_password') }
            </button>
          </div>

          <p styleName="tip_text">{ tr('reset_password.min_length') }</p>
        </div>

        <SpinButton
          styleName="reset_button"
          disabled={!this.properPassword()}
          type="submit"
          showSpinner={this.state.inProgress}
        >
          { tr('reset_password.reset_button') }
        </SpinButton>

        <p /* eslint react/no-danger: 0 */ // We have embedded html in there.
          dangerouslySetInnerHTML={{
            __html: tr('reset_password.disclaimer', { url: 'https://igglo.com/legal/privacy_policy/' })
          }}
          styleName="disclaimer_text"
        />
      </ModalPage>
    );
  }
}

ResetPassword.propTypes = {
  location: locationShape.isRequired
};

export default ResetPassword;
